import { Typography } from '@mui/material';
import { Bar } from 'react-chartjs-2';
import React from 'react';
import ChartWrapper from '../../../../bidder/components/Charts/ChartWrapper';
import {
  downloadPNGByElementId,
  downloadCSVByDataset
} from '../../../../bidder/helpers/chart-helper';

import { getStageLabel } from '../../../../bidder/helpers/stage-helper';
import charts from '../../../../bidder/constants/colors/charts';

const getOptions = () => {
  return {
    plugins: {
      title: {
        text: 'Valoration global',
        display: true
      },
      legend: {
        display: false
      }
    },
    scales: {
      x: {
        grid: {
          display: false,
          drawBorder: false
        }
      },
      y: {
        ticks: {
          display: true
        },
        grid: {
          drawBorder: false
        },
        stacked: true
      }
    },
    maintainAspectRatio: false,
    responsive: true,
    maxHeight: 300
  };
};

export default function GlobalResultByVendor({ data, stage, showDownload = true }) {
  const stageLabel = getStageLabel(stage);
  const id = `${stage.toUpperCase()}-valoration-global`;
  const dataset = {
    labels: data.labels,
    datasets: [
      {
        label: 'Score',
        data: data.data,
        backgroundColor: charts[stage]
      }
    ]
  };

  const downloadCallbackAsImage = () => {
    downloadPNGByElementId(id, id);
  };

  const downloadCallbackAsCSV = () => {
    downloadCSVByDataset(id, dataset);
  };

  return (
    <>
      <ChartWrapper
        headerCallback={() => {
          return (
            <>
              <Typography variant={'body1'}>{stageLabel} Global Results by Vendor</Typography>
            </>
          );
        }}
        downloadCallbackAsImage={showDownload ? downloadCallbackAsImage : null}
        downloadCallbackAsCSV={showDownload ? downloadCallbackAsCSV : null}>
        <Bar id={id} height={300 + 'px'} options={getOptions()} data={dataset} />
      </ChartWrapper>
    </>
  );
}
